export default __webpack_public_path__ + "static/media/sort-dark.92b7a59d.svg";